"use client";

import Link from "next/link";
import { NewsCard } from "./NewsCard";
import { EmptyNewsState } from "./EmptyNewsState";
import { NewsItem } from "@/types/newsType";

interface NewsListProps {
  allNews: NewsItem[];
}

export function NewsList({ allNews }: NewsListProps) {
  if (allNews.length === 0) {
    return (
      <div className="max-w-6xl mx-auto px-4">
        <EmptyNewsState
          title="Chưa có tin tức"
          description="Hiện tại chưa có tin tức nào được đăng tải. Vui lòng quay lại sau."
        />
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-4">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
          Tất cả tin tức
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {allNews.map((news) => (
            <Link
              key={news.id}
              href={`/news/${news.slug || news.id}`}
              className="hover:no-underline"
            >
              <NewsCard news={news} size="medium" />
            </Link>
          ))}
        </div>
      </div>

      {/* Load More Button */}
      <div className="text-center mt-12">
        <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-md font-medium transition-colors">
          Tải thêm tin tức
        </button>
      </div>
    </div>
  );
}
